import router from '@/router'

export async function pushHref(obj) {
  const { href } = router.resolve(obj)
  location.href = href
}
export async function pushNrNs(obj) {
  obj.query = { ...obj.query, cmd: 'share', sharetype: '0', refresh: 'no' }
  pushHref(obj)
}

export async function pushReplace(obj) {
  const { href } = router.resolve(obj)
  location.replace(href)
}
export async function pushReplaceNrNs(obj) {
  obj.query = { ...obj.query, cmd: 'share', sharetype: '0', refresh: 'no' }
  pushReplace(obj)
}
